import React from 'react';
import proptypes from 'prop-types';
import { PayPalMessages } from '@paypal/react-paypal-js';
import { paypalMessageClickNewRelic } from '../utils/NewRelicHelper';

const { string } = proptypes;

const PaypalMessage = (props) => {
  const { fontSize, fromPage, orderTotal } = props;
  const msgStyle = {
    layout: 'text',
    logo: {
      type: 'inline'
    },
    text: {
      color: 'black',
      size: fontSize
    }
  };

  const onClick = () => {
    paypalMessageClickNewRelic(fromPage);
  };

  return (
    <PayPalMessages
      amount={orderTotal}
      forceReRender={[orderTotal]}
      onClick={onClick}
      style={msgStyle}
    />
  );
};

PaypalMessage.propTypes = {
  fontSize: string,
  fromPage: string.isRequired,
  orderTotal: string.isRequired
};

PaypalMessage.defaultProps = {
  fontSize: '12'
};

export { PaypalMessage };